import { Artist } from 'shared/classes/Artist';
import { AdminPerson } from './Person';

export class AdminArtist extends Artist {
  constructor(parameters) {
    super(parameters)

    this.type = 'AdminArtist'

    this.update_person = (person_data) => {
      person_data.artist = undefined; // prevent circular reference
      this.person(new AdminPerson(person_data));
    };

    parameters.person = parameters.person ?? {};
    if (parameters.person.artist) {
      parameters.person.artist = undefined; // prevent circular reference
    }
    this.update_person(parameters.person);

    if (this.person().person_uuid()) {
      this.person().lookupDetails().then((updatedPerson) => {
        this.person(updatedPerson);
      });
    }
  }

  // Fetch the full admin artist record (incl. current_state) and return it as
  // an AdminArtist, mirroring AdminEvent.lookupDetails(). The shared base
  // lookup_details() builds a plain Artist, which silently downgrades the
  // artist (and its nested person) to the non-admin variants.
  lookupDetails = async () => {
    const url = scvm.web_host + "/api/admin/artist";
    const params = new URLSearchParams({ artist_uuid: this.artist_uuid() });
    const response = await fetch(`${url}?${params.toString()}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
    const data = await response.json();
    if (!data.success) {
      console.error(data.pgcode, data.pgerror);
      throw new Error(data.message);
    }
    return new AdminArtist(data.artist);
  };
}


export class RcmdArtist {
  constructor(data) {
    const self = this;
    self.type = "RcmdArtist";

    self.artist_uuid = ko.observable(data.artist_uuid),
    self.artist_name = ko.observable(data.artist_name),
    self.fee_min = ko.observable(data.fee_min ?? '-'),
    self.fee_mid = ko.observable(data.fee_mid ?? '-'),
    self.fee_max = ko.observable(data.fee_max ?? '-'),
    self.invoice_city = ko.observable(data.invoice_city ?? ''),
    self.event_count = ko.observable(data.event_count ?? 0),
    self.invite_count = ko.observable(data.invite_count ?? 0),
    self.profile_picture = ko.observable(data.profile_picture),
    self.admin_ranking = ko.observable(data.admin_ranking),
    self.selected = ko.observable(data.selected),
    self.recommendation_text = ko.observable(data.recommendation_text)
  }
}
